import type { C_ProductInfo } from "~/lib/app.types";

export type VariantRow = {
  id: string;
  displayName: string;
  value: string;
};

export const mapVariationValuesToRows = (
  product: C_ProductInfo | undefined,
): VariantRow[] => {
  const variationValues = product?.variationValues;
  if (!variationValues) return [];
  const rows: VariantRow[] = [];
  for (const [attributeId, value] of Object.entries(variationValues)) {
    if (!value || value === "onesize") continue;
    const attribute = product?.variationAttributes?.find(
      attr => attr.id === attributeId,
    );
    const displayName =
      attribute?.name ||
      attributeId.charAt(0).toUpperCase() + attributeId.slice(1);
    // ET-296: render the AUTHORED value label, not the raw catalog value. A
    // telehealth line's `frequency` is stored as `monthly` / `quarterly` but
    // BM authors them as "Monthly" / "3 Month", so echoing the raw value put
    // a lowercase `monthly` in the mini-cart and would never have produced
    // "3 Month" at all. Same `values.find(...).name` resolution the ET-30 plan
    // selector uses (`treatment-plan-selector.tsx:202`) — though that one uses
    // `??`; here `||`, matching the displayName line above, so an EMPTY
    // authored name falls through to the raw value instead of blanking the
    // row. Falls back to the raw value when the attribute or the value isn't
    // in the product doc either, which is the previous behaviour.
    const displayValue =
      attribute?.values?.find(v => v.value === value)?.name || String(value);
    rows.push({ id: attributeId, displayName, value: displayValue });
  }
  return rows;
};
